export default {
  login: {
    title: 'Ingresar',
    subheading: "¿No tienes una cuenta?",
    buttonText: 'Ingresar',
    errorMessages: {
      default: 'Tu correo electrónico o contraseña no coinciden. {br}Por favor, inténtalo nuevamente.',
      session_expired: 'You were inactive for a while so your session has expired. Please log in again.',
    },
  },
  storeLogin: {
    title: 'Completa tu orden',
    subheading:
        "Es más que una simple placa o rastreador; es el pase que permite a tu mascota regresar a casa. Para aprovechar al máximo los beneficios del servicio de mascotas perdidas Home<em>Safe</em><sup>&reg;</sup>, necesitamos información esencial sobre ti y tu mascota. Ingresa o Regístrate para completar tu orden.",
    buttonTextSignUp: 'Regístrate',
    buttonTextLogIn: 'Ingresar',
    or: 'O',
    lowerHeader: "¡Es más que una simple placa o rastreador!",
  },
  forgotPassword: {
    title: '¿Olvidaste tu contraseña?',
    info: '¡No hay problema! Te enviaremos un enlace a tu correo electrónico para cambiar tu contraseña y que puedas acceder a tu cuenta.',
    buttonText: 'Cambiar contraseña',
    onSuccess: {
      title: '¡Casi listo!',
      info: 'Si tienes una cuenta, te enviaremos un correo electrónico con instrucciones para cambiar tu contraseña.',
    },
  },
  resetPassword: {
    title: 'Cambiar tu contraseña',
    subheading: '¡Casi listo! Crea una nueva contraseña a continuación.',
    buttonText: 'Cambiar contraseña',
    password: {
      title: 'Nueva contraseña',
    },
    passwordConfirm: {
      placeholder: 'Re-Enter password',
      title: 'Confirm New Password',
    },
    onSuccess: {
        title: '¡Éxito!',
        infoText: 'Tu contraseña fue actualizada.',
        buttonText: 'Volver a Ingresar',
    },
    errorMessages: {
        default: 'Hubo un problema con el cambio de contraseña. Por favor, inténtalo de nuevo.',
        currentPassword: 'La nueva contraseña no puede ser la misma que la contraseña actual',
        mismatch: 'La confirmación de la contraseña no coincide',
    },
  },
  completeActivation: {
    loading: {
      title: 'Fetching your Record',
      subheading: "You'll be able to create your online account very shortly",
    },
    title: '¡Hola {firstName}!',
    subheading: 'Tu cuenta segura en línea puede usarse para…',
    subheadingList: [
      'Licenciar a tus mascotas',
      'Actualizar el estado de propiedad de tus mascotas',
      'Actualizar tu dirección actual e información de contacto',
      '¡Y mucho más!',
    ],
    nonLicensing: {
      title: 'Ya casi terminas.',
      subheading: 'Crea tu contraseña y súmate a un mundo hecho para proteger a {petName} y darte tranquilidad.',
      petFallback: 'tu mascota',
    },
    legalText: {
      prepend: "By signing up, you agree to DocuPet's",
      links: {
        termsOfService: 'Terms of Service',
        conjunction: 'and',
        privacyPolicy: 'Privacy Policy',
      },
    },
    buttonText: 'Completar registro',
    errorMessages: {
      access_code_used: "¡Parece que ya te has registrado! {br} {action}",
      default: 'There was a problem with your complete sign-up.{br}Please try again.',
      action: {
        access_code_used: 'Haz clic aquí para ingresar',
      },
    },
    nasn: {
      title: '¡Bienvenido a la familia, {petNames}!',
      subheadingSingular:
        'Crea una contraseña para obtener la placa gratuita de {petNames} y acceso a ayuda 24/7 para mascotas perdidas. Solo toma un momento proteger a tu nuevo mejor amigo.',
      subheadingPlural:
        'Crea una contraseña para obtener las placas gratuitas de tus mascotas y acceso a ayuda 24/7 para mascotas perdidas. Solo toma un momento proteger a tus nuevos mejores amigos.',
      finishTheDetails: 'Completa los detalles',
      helpGetLostPetsHome: 'Ayuda a que las mascotas perdidas regresen a casa',
      stayInformed: 'Mantente informado',
      buttonText: 'Obtén tu placa gratuita',
    },
  },
  fetchMyRecord: {
    title: 'Acceder a mi registro de licencia',
    subheading:
      'Si ya has licenciado a tu mascota con {getCityOrganization} antes, es posible que tengamos tu registro en nuestros archivos. ¡Vamos a buscarlo! Si nunca has licenciado a tu mascota con {getCityOrganization}, {action}.',
    buttonText: {
      primary: 'Buscar',
    },
    actionText: {
      signUpHere: "regístrate aquí"
    },
    nonLicensing: {
      title: '¡Protejamos a tu mascota!',
      subheading: 'Tu código de acceso te da acceso a la identificación completa, protección y cuidado.',
    },
    byAccessCode: {
      linkText: '¿Quieres ver un ejemplo',
      descriptionLineOne: 'de un "Código de Acceso"',
      descriptionLineTwo: 'que te enviamos por correo postal o correo electrónico?',
      title: 'He recibido un código de acceso mediante correo postal, teléfono o correo electrónico',
      subheading: 'I have an access code from a letter or email',
      buttonText: {
        secondary: "I will use my pet's tag number",
      },
      modal: {
        accessCodeExample:{
          title:'Ejemplo de Código de Acceso',
        },
        accessCode: {
          title: "¿Qué es un Código de Acceso?",
          content:
            "Cuando recibimos registros de {getCityOrganization}, enviamos recordatorios de renovación de licencia con Códigos de Acceso por correo postal y por correo electrónico (si se ha proporcionado una dirección de correo). Estos códigos únicos solo pueden usarse si la información de contacto proporcionada coincide con la del registro original. Una vez que tu código de acceso haya sido utilizado exitosamente para vincularse con tu cuenta, podrás proceder a crear tus credenciales para tu cuenta en línea, donde encontrarás todos los detalles relacionados con la licencia de tu mascota.",
        },
      },
      errorMessages: {
        invalid_access_code:
          'Incorrect Access code or Zip code. Please check your email or letter to confirm the correct information.',
        access_code_used: "¡Parece que ya te has registrado! {br} {action}",
        default: 'There was problem fetching your record. Please try again.',
        action: {
          access_code_used: 'Haz clic aquí para ingresar',
        },
        onlyAlphaNumericCharacters: 'El {field} solo puede contener caracteres alfanuméricos',
        not_found:"Hmm... no podemos encontrar un registro que coincida con estos datos. Por favor, asegúrate de haber ingresado la información correctamente.",
      },
      footerMessage:{
        fallbackText:"Si esto no funciona, puedes intentar",
        fallbackLinkText:"usar el número de placa de licencia actual de tu mascota para acceder a tu registro",
        learnMoreText: "Obtén más información sobre cómo buscamos registros existentes",
      }
    },
    byTagNumber: {
      title: 'Ingresar el número de placa de mi mascota en su lugar',
      subheading: "I have my pet's tag number",
      buttonText: {
        secondary: 'I will use my access code',
      },
      errorMessages: {
        invalid_tag_number:
          'Incorrect Tag number or Pet Name or Zip code or Phone number. Please check your email or letter to confirm the correct information.',
        access_code_used: "¡Parece que ya te has registrado! {br} {action}",
        default: 'There was problem fetching your record. Please try again.',
        action: {
          access_code_used: 'Click here to Log In',
        },
        not_found: "No hemos podido encontrar una coincidencia exacta para estos datos en nuestros registros. Por favor, asegúrate de haber ingresado la información correctamente y considera probar con otros números de teléfono."
      },
      modal: {
        infoTitle: "¿Cuál es el número de placa de licencia actual de mi mascota?",
        modalDescription: "Normalmente contamos con registros de licencias anteriores que incluyen los números de placa de las mascotas. Si tu mascota lleva una placa, usa el número que aparece en ella aquí. Si esta información, junto con el nombre de la mascota, tu código postal y tu número de teléfono, coincide con uno de tus registros, ¡podremos vincular tu registro! Luego podrás crear una cuenta en DocuPet y verás la información de tu licencia en tu perfil en línea.",
      },
      footerMessage: {
        fallbackIntro: "Si has recibido un Código de Acceso",
        fallbackDescription:
          "de nuestra parte, puedes ingresarlo aquí. O, si crees que {cityOrganization} podría tener un correo electrónico asociado con tu registro de licencia anterior, puedes solicitar un Código de Acceso",
        learnMoreText: "Obtén más información sobre cómo buscamos registros existentes",
      },
      support: {
        customerCarePrefix:
          "If these options don't work for you, we're sorry for the inconvenience."
      },
    },
  },
  requestAccessCode: {
    title: 'Request Access Code',
    subheading: 'We may be able to email a new access code to you. Enter your Email Address below.',
    buttonText: 'Continuar',
    onSuccess: {
      title: 'Almost Done!',
      infoText:
        "We've sent an access code to {email} with instructions to access your account. If the email doesn't arrive soon, please check your spam folder",
      buttonText: 'Return to Fetch My Record',
    },
    errorMessages: {
      invalid_email:
        "We can't find this email address in our system. Please check to see that you're entering the correct email address.",
      access_code_used: "¡Parece que ya te has registrado! {action}",
      default: 'There was problem sending an email. Please try again.',
      action: {
        access_code_used: 'Haz clic aquí para ingresar',
      },
    },
    footerMessage: {
      errorDescription: "No podemos encontrar esa dirección de correo electrónico en nuestros registros. Es posible que esta información no se nos haya proporcionado previamente. Por favor, asegúrate de haber ingresado la información correctamente.",
      fallbackIntro: "Puedes intentar",
      fallbackStrong: "usar el número de placa de licencia de tu mascota para acceder",
      fallbackDescription: "a tu registro",
      learnMoreText: "Obtén más información sobre cómo buscamos registros existentes",
      successMessage: "Te hemos enviado un correo electrónico con tu código de acceso. Ahora puedes buscar tu registro usando tu código de acceso.",
    },
    validation: {
      emailNotFound: "No podemos encontrar esa dirección de correo electrónico en nuestros registros."
    },
    modal: {
      title: "¿Cómo obtenemos tus registros de licencia existentes?",
      sectionWhyTitle: "Por qué es importante coincidir con los registros existentes",
      sectionWhyDescription:
        "{cityOrganization} nos ha proporcionado registros de licencias de mascotas existentes para que podamos enviar recordatorios y mantener tu información actualizada. Es muy importante que los registros existentes se mantengan actualizados para evitar duplicados y enviar recordatorios innecesarios.",

      sectionAccessCodeTitle: "¿Qué son los \"Códigos de Acceso\" de DocuPet?",
      sectionAccessCodeDescription:
        "Cuando enviamos recordatorios de renovación por correo postal o electrónico (cuando tenemos esta información registrada) a los dueños de mascotas que aún no han creado una cuenta en DocuPet, incluimos un Código de Acceso. Estos códigos únicos garantizan que solo la información de contacto registrada pueda ser utilizada para acceder a cada registro.",

      sectionMatchingTitle: "Coincidencia de datos de la mascota y el dueño",
      sectionMatchingDescription:
        "A veces, los dueños que previamente han licenciado a sus mascotas con {cityOrganization} llegan a nuestro sitio para renovar la licencia sin haber recibido todavía un Código de Acceso. En estos casos, a menudo podemos localizar un registro previo mediante coincidencia de datos. Solicitaremos el número de placa actual, el nombre de la mascota, tu código postal y tu número de teléfono. Si toda esta información coincide, podremos recuperar tu registro.",

      sectionAccountTitle: "Crear una cuenta en DocuPet",
      sectionAccountDescription:
        "Una vez que hayamos vinculado tu registro, te enviaremos a la página de creación de cuenta. Cuando ingreses tu dirección de correo electrónico y crees una contraseña, encontrarás la información de licencia existente de tu mascota en tu perfil en línea."
    },
    successButtonText: "Buscar mi registro mediante Código de Acceso",
  },
  // HomeSafe
  HomeSafe: '{HomeSafe}',
  homeSafe: {
    content: [
      'The unique code on this tag serves as an identifier to help get your pet home quickly if they become lost',
      'Proactively send lost pet alerts from your account',
      'Automatically receive an alert if your pet is found',
    ],
  },
  // Info
  onlineAccount: {
    heading: 'Tu cuenta en línea de Docupet incluye:',
    content: [
      'Cientos de estilos de placa de diseñador, o la opción de crear tu propio diseño',
      'Acceso gratuito 24/7 al servicio de mascotas perdidas HomeSafe®',
      'Un panel central con la información y los registros de tu mascota',
    ],
  },
  text: {
    light: {
      WelcomeTo: 'Welcome to',
    },
    bold: {
      DocuPet: 'DocuPet',
    },
  },
  input: {
    email: {
      label: 'Correo electrónico',
      placeholder: 'Ingresar correo electrónico',
    },
    password: {
      label: 'Contraseña',
      placeholder: 'Ingresa tu contraseña',
      buttonText: {
        show: 'Show',
        hide: 'Hide',
      },
    },
    createPassword: {
      label: 'Crear una contraseña',
      placeholder: 'Crear una contraseña',
    },
    newPassword: {
      label: 'Nueva contraseña',
      placeholder: 'Crear contraseña',
    },
    passwordConfirm: {
      label: 'Confirmar nueva contraseña',
      placeholder: 'Reingresar nueva contraseña',
    },
    accessCode: {
      label: 'Ingresar mi código de acceso de 8 o 9 dígitos',
      placeholder: 'Ingresar código de acceso (ej. FAB12345)',
      errorMessages: 'Código de acceso requerido',
      onlyAlphaNumericCharacters: 'El código de acceso solo puede contener caracteres alfanuméricos'
    },
    postalCode: {
      label: 'Código postal asociado al registro',
      placeholder: 'Ingresa tu código postal',
      errorMessages: 'Por favor, ingresa tu código postal',
    },
    tagNumber: {
      label: 'Número de placa',
      placeholder: 'Ingresa el número de placa (ej. A1B27890)',
      aboveLabel: 'El número de placa y dos de los tres campos siguientes deben coincidir para poder acceder a tu registro de licencia.',
      errorMessages: {
        tag_number_required: 'Por favor, ingresa exactamente lo que aparece en la placa',
      },
    },
    petName: {
      label: 'Nombre de la mascota',
      placeholder: 'Ingresa el nombre de tu mascota',
      errorMessages: 'Por favor, ingresa el nombre de tu mascota',
    },
    phoneNumber: {
      label: 'Número de teléfono asociado con tu registro',
      placeholder: 'Por favor, ingresa tu número de teléfono',
      customErrorMessage: 'Por favor, ingresa los diez dígitos de tu número de teléfono',
    },
  },
  checkbox: {
    eula: 'I agree',
    petalert: 'Quisiera recibir alertas sobre mascotas perdidas cerca de mi domicilio.',
    shelter: 'Quisiera compartir mi perfil con la Red Nacional de Refugios de Animales para que me ayuden a reunirme con mis mascotas si alguna vez se pierden.',
  },
  link: {
    accessCode: {
      dontHave: "¿No tienes un código de acceso?",
    },
    signUp: 'Regístrate',
    forgotPassword: '¿Olvidaste tu contraseña?',
    login: {
      return: 'Volver a Ingresar',
    },
    fetchMyRecord: {
      return: 'Return to Fetch My Record',
    },
  },
  validations: {
    messages: {
      required: 'req',
    },
  },
  footer: {
    copyright: 'DocuPet Corp. All rights reserved.',
    links: {
      about: 'About DocuPet',
      tos: 'Terms of Service',
      privacy: 'Privacy Policy',
    },
  },
  meta: {
    title: {
      LogIn: 'Log In',
      ResetPassword: 'Reset your password',
      ForgotPassword: 'Forgot your password?',
      CompleteSignup: 'Complete your sign-up',
      RequestAccessCode: 'Request access code',
      FetchMyRecordByPetTag: 'Fetch my record',
      FetchMyRecordByAccessCode: 'Fetch my record',
      FetchMyRecordByTagNumber: 'Fetch my record',
      StoreLogIn: 'Store Log In',
    },
  },
  CUSTOMER_CARE_PHONE: '1-877-239-6072',
};
